/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_AmateurInputs */

const en_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respecting and preserving the human body`)
};

const es_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuida tu cuerpo y protégelo`)
};

const de_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den menschlichen Körper respektieren und schützen`)
};

const zh_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尊重并保护人的身体`)
};

const ar_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احترام الجسم البشري والحفاظ عليه`)
};

const fr_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respecter et préserver le corps humain`)
};

const vi_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tôn trọng và bảo tồn cơ thể con người`)
};

const sw_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuheshimu na kuulinda mwili wa binadamu`)
};

const th_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เคารพและถนอมร่างกายมนุษย์`)
};

const bs_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poštovanje i očuvanje ljudskog tijela`)
};

const ja_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人の体を尊重し、守る`)
};

const ko_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인체를 존중하고 보호하기`)
};

const pt_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respeitar e preservar o corpo humano`)
};

const it_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispettare e preservare il corpo umano`)
};

const sv_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respekt för och bevarande av människokroppen`)
};

const nl_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het menselijk lichaam respecteren en beschermen`)
};

const da_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respekt for og bevarelse af den menneskelige krop`)
};

const nb_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respekt for og bevaring av menneskekroppen`)
};

const fi_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihmiskehon kunnioittaminen ja suojeleminen`)
};

const pl_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szacunek dla ludzkiego ciała i jego ochrona`)
};

const ru_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уважение к человеческому телу и его сбережение`)
};

const tr_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İnsan vücuduna saygı duymak ve onu korumak`)
};

const hi_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मानव शरीर का सम्मान और संरक्षण`)
};

const id_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghormati dan menjaga tubuh manusia`)
};

const ms_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghormati dan memelihara tubuh manusia`)
};

const cs_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respekt k lidskému tělu a jeho ochrana`)
};

const el_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σεβασμός και διατήρηση του ανθρώπινου σώματος`)
};

const he_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כבוד לגוף האדם ושמירה עליו`)
};

const af_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respek en bewaring van die menslike liggaam`)
};

const hu_method_content_step_06_amateur = /** @type {(inputs: Method_Content_Step_06_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az emberi test tisztelete és megőrzése`)
};

/**
* | output |
* | --- |
* | "Respecting and preserving the human body" |
*
* @param {Method_Content_Step_06_AmateurInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_amateur = /** @type {((inputs?: Method_Content_Step_06_AmateurInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_AmateurInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_amateur(inputs)
	if (locale === "de") return de_method_content_step_06_amateur(inputs)
	if (locale === "zh") return zh_method_content_step_06_amateur(inputs)
	if (locale === "ar") return ar_method_content_step_06_amateur(inputs)
	if (locale === "fr") return fr_method_content_step_06_amateur(inputs)
	if (locale === "vi") return vi_method_content_step_06_amateur(inputs)
	if (locale === "sw") return sw_method_content_step_06_amateur(inputs)
	if (locale === "th") return th_method_content_step_06_amateur(inputs)
	if (locale === "bs") return bs_method_content_step_06_amateur(inputs)
	if (locale === "ja") return ja_method_content_step_06_amateur(inputs)
	if (locale === "ko") return ko_method_content_step_06_amateur(inputs)
	if (locale === "pt") return pt_method_content_step_06_amateur(inputs)
	if (locale === "it") return it_method_content_step_06_amateur(inputs)
	if (locale === "sv") return sv_method_content_step_06_amateur(inputs)
	if (locale === "nl") return nl_method_content_step_06_amateur(inputs)
	if (locale === "da") return da_method_content_step_06_amateur(inputs)
	if (locale === "nb") return nb_method_content_step_06_amateur(inputs)
	if (locale === "fi") return fi_method_content_step_06_amateur(inputs)
	if (locale === "pl") return pl_method_content_step_06_amateur(inputs)
	if (locale === "ru") return ru_method_content_step_06_amateur(inputs)
	if (locale === "tr") return tr_method_content_step_06_amateur(inputs)
	if (locale === "hi") return hi_method_content_step_06_amateur(inputs)
	if (locale === "id") return id_method_content_step_06_amateur(inputs)
	if (locale === "ms") return ms_method_content_step_06_amateur(inputs)
	if (locale === "cs") return cs_method_content_step_06_amateur(inputs)
	if (locale === "el") return el_method_content_step_06_amateur(inputs)
	if (locale === "he") return he_method_content_step_06_amateur(inputs)
	if (locale === "af") return af_method_content_step_06_amateur(inputs)
	if (locale === "hu") return hu_method_content_step_06_amateur(inputs)
	return en_method_content_step_06_amateur(inputs)
});